import { render, staticRenderFns } from "./TestingOrders.vue?vue&type=template&id=4f5d1385&scoped=true"
import script from "./TestingOrders.vue?vue&type=script&lang=js"
export * from "./TestingOrders.vue?vue&type=script&lang=js"
import style0 from "./TestingOrders.vue?vue&type=style&index=0&id=4f5d1385&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d1385",
  null
  
)

export default component.exports